import { useMemo } from "react";
import { useAppSelector } from "@/app/appStore";
import { selectHandProjections } from "@/entities/annotation/model/slices/slice";
import { selectSelectedClosestGondolaDistItem } from "@/entities/gondola-change-groups";
import { PlaybackState, useMediaState } from "@tezzro/player";
import TrackPin from "./track-pin";
import useTrackPins from "@/shared/hooks/useTrackPins";

const TrackPins = () => {
  const handProjections = useAppSelector(selectHandProjections);
  const selectedClosestGondolaDistItem = useAppSelector(
    selectSelectedClosestGondolaDistItem
  );
  const playbackState = useMediaState("playbackState");

  const selectedTrackId =
    handProjections?.trackId || selectedClosestGondolaDistItem?.track_id;

  const { positionedTrackPins, trackPinsLoading } = useTrackPins();

  const isTrackPinLoading = useMemo(
    () =>
      trackPinsLoading ||
      ![PlaybackState.Paused, PlaybackState.Idle].includes(playbackState),
    [trackPinsLoading, playbackState]
  );

  return (
    positionedTrackPins?.length > 0 &&
    positionedTrackPins.map((pin) => (
      <TrackPin
        key={pin.trackId}
        size={32}
        animalName={pin.animalName}
        x={pin.x}
        y={pin.y}
        color={pin.color}
        isLoading={isTrackPinLoading}
        isHighlighted={selectedTrackId === pin.trackId}
      />
    ))
  );
};

export default TrackPins;
